import { Violation, ViolationSeverity } from './../violation';
import { getPropertyRulesFor, updatePropertyRulesFor } from './utils';

export class NonNegativeError extends Violation {
    public constructor(message: string) {
        super(ViolationSeverity.Error, message);
    }
}

export function NonNegative(message: string): PropertyDecorator {
    return (target: Object, propertyKey: string | symbol): void => {
        const key = propertyKey as string;
        const propertyRules = getPropertyRulesFor(target, key);

        propertyRules.push([{
            async: false,
            violationType: NonNegativeError.bind(null, message),
            validate: (context) => {
                const value = context.source[key];
                return value >= 0;
            }
        }, {}]);

        updatePropertyRulesFor(target, key, propertyRules);
    };
}
